module.exports = __webpack_public_path__ + "img/img_integral_detail.dafdbcb8.png";